module.exports = __webpack_public_path__ + "65f55ace503bfa030a62aec038eb47f7.png";